
/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */

require('./bootstrap');

$(".dropdown-trigger").dropdown({
    constrainWidth: false
});
$('select').formSelect();
$('.sidenav').sidenav();
$('.parallax').parallax();



// WEBPACK FOOTER //
// ./resources/assets/js/app.js